export default __webpack_public_path__ + "static/media/premiumIcons.6b3d6c82.svg";